import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../lib/constants";
import { HelpCircle } from "lucide-react";

const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-28 bg-white" data-testid="section-faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-megha-accent">
            <HelpCircle className="w-3.5 h-3.5" /> Frequently Asked
          </div>
          <h2 className="mt-2 font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-megha-text">
            Questions, answered.
          </h2>
          <p className="mt-3 text-slate-600">
            Can't find what you're looking for? Call us at <span className="font-bold text-megha-text">+91 78159 10875</span>.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="accordion-faq">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-slate-50 hover:bg-white border border-slate-100 hover:border-megha-accent/30 hover:shadow-md rounded-2xl px-5 transition-all"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base md:text-lg font-heading font-bold text-megha-text hover:text-megha-accent py-5 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm md:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
